import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const Index = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    // Only redirect after auth state is loaded
    if (!loading) {
      if (user) {
        navigate('/dashboard');
      } else {
        navigate('/auth');
      }
    }
  }, [navigate, user, loading]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="animate-pulse">
        <div className="h-12 w-12 rounded-full bg-primary flex items-center justify-center mx-auto">
          <span className="text-white font-bold text-xl">SR</span>
        </div>
        <div className="mt-4 text-center">
          <p className="text-lg text-muted-foreground">Loading...</p>
        </div>
      </div>
    </div>
  );
};

export default Index;
